import Vue from 'vue';

Vue.filter('parseComment', (value: string) => {
  return value ? value.replace(/\n/gm, '<br/>') : '';
});
